<script setup>
import TrayCard from './TrayCard.vue';

defineProps({
  trays: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <div class="trays-grid">
    <TrayCard v-for="tray in trays" :key="tray.uuid" :tray="tray" />
  </div>
</template>
